import React from 'react'
import { Switch, Route } from "react-router-dom"
import Hotels from './hotels.page'
import CreateHotel from './create/create.page'
import EditHotel from './edit/edit.page'

const HotelController = () => {
    return (
        <Switch>
            <Route path="/content/hotels/edit/:id" component={EditHotel} />
            <Route path="/content/hotels/create" component={CreateHotel} />
            <Route exact path="/content/hotels" component={Hotels} />
        </Switch>
    )
}

export default HotelController
